export const businessVI = {
    "business": {
        "message": {
            "add": "Tạo mới khối nghiệp vụ thành công"
        },
        "name":"Tên",
        "department":"Phòng ban"
    }
}